<template>
    <div>
        <div class="news-banner">
            <img src="../../../assets/images/banner7.png" alt="">
        </div>
        <!-- 面包屑 -->
        <Breadcrumb separator=">" class="nav_rot">
            <Breadcrumb-item><router-link to="/">首页</router-link></Breadcrumb-item>
            <Breadcrumb-item><router-link to="/news">新闻中心</router-link></Breadcrumb-item>
            <Breadcrumb-item>公司动态</Breadcrumb-item>
        </Breadcrumb>

        <!-- 公司动态第一张内容 -->
        <div class="publish_main">
            <p>AI算法组在公安部举办的竞赛中荣获单项总排名第四</p>
            <p class="con_p">
                   12月1日，由道路交通安全公安部重点实验室组织、交通违法行为智能分析研究室承办的“道路车辆图像特征人工智能识别算法竞赛”活动正式开幕，
                   全国从事车辆图像识别技术研究的主流企业、科研院校等46家单位参加测评，聚焦污损遮挡号牌检测、渣土车特征检测、
                   驾驶员人脸识别等6个主题展开人工智能识别算法竞赛。
            </p>
             <p class="con_p">
                   本次大赛主题“AI：让行为识别更智能，让隐患预警更精准”，旨在充分利用道路监控视频图像数据资源，汇聚行业智慧，
                   提高道路车辆图像特征识别算法技术在交管业务实战中的应用水平，实现人工智能赋能交通管理工作。
            </p>
            <p class="con_p">
                   我司算法组李康、韩德伟、郝欣童、孙昊、杨勖等组成的项目组代表清华未来实验室参赛，在此次比赛中表现突出，在强手如林的激烈竞争中及时总结经验，调整策略，克服不利因素，取得了单项小组第一、单项总排名第四的优异成绩，为公司争得了荣誉！
            </p>
            <img src="../../../assets/images/7.png" alt="" class="fircon_img">
            <div class="contest_imgs">
                <img src="../../../assets/images/8.png" alt="">
                <img src="../../../assets/images/9.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import header from "../../cuscom/header";
export default {
    beforeRouteEnter: (to, from, next) => {
            next(vm => {
             window.scrollTo(0,0)
            });
        },
}
</script>

<style>
.news-banner {
     width: 100%;
 }
 .news-banner img {
     width: 100%;
     height: 100%;
 }

/* 面包屑 */
.nav_rot {
    width: 1200px;
    margin: 0 auto;
    font-size: 18px;
    margin-top: 35px;
}
.ivu-breadcrumb-item-link {
    color: #333333;
}


.publish_main {
    width: 1200px;
    margin: 0 auto;
    color: #333;
    margin-top: 94px;
    overflow: hidden;
    padding-bottom: 60px;
}
.publish_main p:nth-child(1) {
    font-size: 36px;
    /* font-weight: 700; */
    text-align: center;
    margin-bottom: 45px;
}
.publish_main .con_p {
    font-size: 14px;
    text-indent: 2em;
}
.publish_main .fircon_img{
    display: block;
    margin: 0 auto;
    margin-bottom: 50px;
    margin-top: 55px;
}

/* 下方两张图片 */
.contest_imgs {
    height: 468px;
    padding: 30px;
}
.contest_imgs img:nth-child(1) {
    float: left;
    margin-top: 0px;
    /* margin-top: 60px; */
}
.contest_imgs img:nth-child(2) {
    float: right;
    margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/news/contest/contest.vue